import React from 'react';
import { Divider, Grid } from '@material-ui/core';
import styles from './styles.module.scss';
import AloLogo from 'src/assets/icons/AloLogo';

const WarmthGuideModel = ({ isMobile = false }: AloWarmthGuideModel) => {
  return (
    <Grid container className={styles.warmthModel} direction={isMobile ? 'column' : 'row'} spacing={2}>
      <Grid item xs={12} className="display-center">
        <h4>
          <AloLogo className="alo-logo__svg" />
        </h4>
      </Grid>
      <Grid item xs={12} className="display-center">
        <div className="warmth-guide-model-title">Warmth Guide</div>
      </Grid>
      <Grid
        container
        direction={isMobile ? 'column' : 'row'}
        alignItems="flex-start"
        justify="flex-start"
        spacing={2}
        className="warmth-guide-model-body"
        xs={12}
      >
        <Grid item xs>
          <div className="display-center model-single-heat-wave">
            <span className="alo-single-heat-wave-icon single-heat-wave"></span>
          </div>
          <div className="warmth-type-label display-center">Warm</div>
          <div className="warmth-guide-details display-center">
            Keep out the chill with light, just-right coverage — perfect for transitional weather or to-and-from the
            studio on cool mornings. Layer them up for added warmth when temperatures drop and wear them all year long.
          </div>
        </Grid>
        <Divider
          className={isMobile ? 'warmth-divider-line-display' : 'warmth-divider'}
          orientation="vertical"
          variant="middle"
          flexItem
        ></Divider>
        <Grid item xs>
          <div className="display-center">
            <span className="alo-double-heat-wave-icon"></span>
          </div>
          <div className="warmth-type-label display-center">Warmer</div>
          <div className="warmth-guide-details display-center">
            Not too hot, not too cold — just right for colder climates, Cali winters and leveling up when temps drop.
            Plush textures and warming fabrics are perfect solo or layered for the coldest weather.
          </div>
        </Grid>
        <Divider
          className={isMobile ? 'warmth-divider-line-display' : 'warmth-divider'}
          orientation="vertical"
          variant="middle"
          flexItem
        ></Divider>
        <Grid item xs>
          <div className="display-center">
            <span className="alo-heat-wave-icon heat-wave"></span>
          </div>
          <div className="warmth-type-label display-center">Warmest</div>
          <div className="warmth-guide-details display-center">
            It doesn’t get warmer than this. Thick, wind-blocking fabrics and insulation keep cold air out and your body
            warmth in, to keep you toasty in any weather. Wear all winter or on cold nights and mornings all year.
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface AloWarmthGuideModel {
  isMobile?: boolean;
}

export default WarmthGuideModel;
